import type { SlotGrid } from '../rendering/types';

export interface ReelAnticipation {
  readonly reel: number;
  readonly anticipated: boolean;
  readonly scatterReelsBefore: number;
  readonly scatterStageAtStop: 0 | 1 | 2 | 3;
}

export function getScatterReels(grid: SlotGrid): readonly boolean[] {
  return grid.map((reel) => reel.includes('SCATTER'));
}

export function createScatterAnticipationPlan(grid: SlotGrid): readonly ReelAnticipation[] {
  const scatterReels = getScatterReels(grid);
  let seen = 0;
  return scatterReels.map((hasScatter, reel) => {
    const entry: ReelAnticipation = {
      reel,
      anticipated: reel > 0 && seen >= 2,
      scatterReelsBefore: seen,
      scatterStageAtStop: Math.min(3, seen + (hasScatter ? 1 : 0)) as 0 | 1 | 2 | 3,
    };
    if (hasScatter) seen += 1;
    return entry;
  });
}
